import { createClient } from '@supabase/supabase-js';

// Supabase bağlantı bilgileri
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || "https://hfivknhspcrzhsbomtul.supabase.co";
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhmaXZrbmhzcGNyemhzYm9tdHVsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM2OTA3ODMsImV4cCI6MjA1OTI2Njc4M30.2n57H7kea3pHlRpA7T3ijlT9dIhM2g1B41HzPsqLNps";
const SUPABASE_SERVICE_KEY = process.env.REACT_APP_SUPABASE_SERVICE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhmaXZrbmhzcGNyemhzYm9tdHVsIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc0MzY5MDc4MywiZXhwIjoyMDU5MjY2NzgzfQ.ihOIPhivLX_TUjK6ixa5b83gO4zz3xOanm7wEVz7J6A";

// Supabase istemcisi
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
export const supabaseAdmin = createClient(SUPABASE_URL, SUPABASE_SERVICE_KEY);

// License Keys tablosunu kontrol et veya oluştur
export const ensureLicenseKeysTable = async () => {
  try {
    // Sorgu testi yap
    const { data, error } = await supabaseAdmin
      .from('license_keys')
      .select('count', { count: 'exact' })
      .limit(1);
    
    if (error && error.code === '42P01') {
      console.log('License keys tablosu mevcut değil, SQL oluşturulmalı');
      
      // Bu kısmı yalnızca bilgilendirme amaçlı tutuyoruz, gerçekte tablo oluşturma SQL'i uygulanmalı
      const sqlCommand = `
        CREATE TABLE IF NOT EXISTS license_keys (
          id SERIAL PRIMARY KEY,
          key TEXT UNIQUE NOT NULL,
          product_type TEXT NOT NULL DEFAULT 'Spoofer',
          key_type TEXT NOT NULL,
          created_date TIMESTAMPTZ NOT NULL,
          expiry_date TIMESTAMPTZ,
          is_active BOOLEAN NOT NULL DEFAULT true,
          description TEXT,
          notes TEXT,
          hwid TEXT,
          usage_count INTEGER NOT NULL DEFAULT 0
        );
      `;
      
      return {
        exists: false,
        sql: sqlCommand
      };
    }
    
    return {
      exists: true
    };
  } catch (error) {
    console.error('Tablo kontrolü sırasında hata:', error);
    return {
      exists: false,
      error: error.message
    };
  }
};

export default supabase; 